import { FullParameters, PartialParameters } from '../../parameters/types'
import { getStatements } from '../../i18n/Statements'
import { AnswserScoreType } from '../../services/types'
import { DEFAULT_ASGN_STATE, DEFAULT_AUTH_STATE } from '../defaultState'
import { AUTO_ENTRY } from '../../parameters/parameters'
import { AsgnStateType, Assignation, CommonValueType } from '../types'
import { RestorableRoundData, SessionData } from './types'
import _ from 'lodash'
import { indexFromLang } from '../../i18n/useTranslation'

// FIXME wrong, we can still rank it (sort confirm)
const isActiveRound = (r: RestorableRoundData) =>
    r.originalShuffledRound.length > r.partiallyRankedRound.length

/**
 * FIXME : to save 360:
 *     // const allStms: Assignation[] = [
    //     ...savedRounds[0].originalShuffledRound,
    //     ...savedRounds[1].originalShuffledRound,
    //     ...savedRounds[2].originalShuffledRound,
    // ]
//  cf. prepareRounds() & resetAsgnState()
 * @param restoredSessionData 
 * @param commons 
 */
export const restoreSession = (
    restoredSessionData: SessionData,
    commons: CommonValueType,
    loginState: typeof DEFAULT_AUTH_STATE,
    newParams?: PartialParameters //TODO to include in sessionData
): void => {
    const { restorable } = restoredSessionData
    const {
        savedRounds,
        userId, //FIXME
        source, //TODO check if stored in sessionData
        slug = '', //TODO check if stored in sessionData
        from = '', //TODO check if stored in sessionData
        lang,
        currentRoundIndex,
        fsmState,
    } = restorable
    
    const langIndex = indexFromLang(lang);
    const stmsMap = _.keyBy(getStatements(langIndex, { is360: false }), 'valueKey')
    const hydrateStm = (valueKey: string) => ({ ...stmsMap[valueKey] })

    const initState = commons.state ?? DEFAULT_ASGN_STATE
    const params: FullParameters = {
        brandParams: _.defaults(
            _.cloneDeep(newParams?.brandParams),
            commons.state.params.brandParams,
            initState.params.brandParams,
        ),
        assessmentParams: _.defaults(
            _.cloneDeep(newParams?.assessmentParams),
            commons.state.params.assessmentParams,
            initState.params.assessmentParams,
        ),
    }
    params.assessmentParams['langIndex'] = langIndex
    console.debug('restoring sessionData', { params, newParams })

    // misc tsf
    const nRounds = params.assessmentParams['Nb of rounds']
    const nValues = params.assessmentParams['Nb of values']
    params.assessmentParams['Deck size'] = nValues * nRounds
    params.assessmentParams['Buckets'] =
        params.assessmentParams['Buckets'] === AUTO_ENTRY.v
            ? nValues
            : params.assessmentParams['Buckets']

    // I. INIT
    const state: AsgnStateType = {
        ...initState,
        startedAt: new Date(restorable.startedAtStr), //TODO validate fuseau
        params,
        fsmState,
    }
    const rounds: Assignation[][] = [[], [], []]
    const asgnsForRound: Assignation[] = []
    const items2compare: Assignation[] = []
    const items2rank: Assignation[] = []

    const scannedItems: AnswserScoreType[] = []
    const { asgnsLeft2Rank, asgnsRanked } = commons
    asgnsLeft2Rank.current = []
    asgnsRanked.current = []

    // II. CONVERT
    rounds[0] =
        savedRounds[0].partiallyRankedRound.length ===
        savedRounds[0].originalShuffledRound.length
            ? savedRounds[0].partiallyRankedRound.map(hydrateStm)
            : savedRounds[0].originalShuffledRound.map(hydrateStm)
    rounds[1] =
        savedRounds[1].partiallyRankedRound.length ===
        savedRounds[1].originalShuffledRound.length
            ? savedRounds[1].partiallyRankedRound.map(hydrateStm)
            : savedRounds[1].originalShuffledRound.map(hydrateStm)
    rounds[2] =
        savedRounds[2].partiallyRankedRound.length ===
        savedRounds[2].originalShuffledRound.length
            ? savedRounds[2].partiallyRankedRound.map(hydrateStm)
            : savedRounds[2].originalShuffledRound.map(hydrateStm)

    console.debug('active round', currentRoundIndex, rounds)

    const activeRound = savedRounds[currentRoundIndex]
    state.currentRound = currentRoundIndex + 1
    state.currentStmIndex = activeRound.currentStmIndex
    asgnsLeft2Rank.current = activeRound.originalShuffledRound
        .map(hydrateStm)
        .filter(
            (a) =>
                activeRound.partiallyRankedRound.findIndex(
                    (_valueKey) => _valueKey === a.valueKey
                ) === -1
        )
    asgnsRanked.current = activeRound.partiallyRankedRound.map(hydrateStm)
    asgnsForRound.push(...activeRound.originalShuffledRound.map(hydrateStm))

    // III. RESTORE with re-rendering
    console.debug('restoring sessionData', {
        savedRounds,
        //
        state,
        rounds,
        asgnsForRound,
        items2compare,
        items2rank,
        scannedItems,
        //
        asgnsLeft2Rank,
        asgnsRanked,
    })
    // Not defined if 'Undo latest' is clicked
    commons?.setGlobalState &&
        commons?.setGlobalState((s) => ({
            ...s,
            ...loginState,
            // FIXME how is it already restored from session?
            // progresses: [0, 0, 0, 0],
        }))
    commons.setState(state)
    commons.setRounds(rounds)
    commons.setAsgnsForRound(asgnsForRound)
    commons.setItems2compare(items2compare)
    commons.setItems2rank(items2rank) // OK [] => useFSM() repop()
    commons.setSessionData(restoredSessionData)
    commons.setScannedItems(scannedItems)
    commons.setIndex2submit(-1);
}
